/* eslint-disable no-underscore-dangle */
import lowerFirst from 'lodash/lowerFirst';
import groupBy from 'lodash/groupBy';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';

import DetailsModal from '../../global/DetailsModal';
import ListModifier from './ListModifier';
import IconsModifier from './IconsModifier';
import ButtonsModifier from './ButtonsModifier';
import RadioDialsModifier from './RadioDials';
import CheckboxModifiers from './CheckboxModifiers';
import CounterModifier from './CounterModifier';
import TabsModifier from './TabsModifier';

import {
  getActiveTableFinish,
  getAddOnModifiers,
  getIsProductDataPending,
  getProductDetails,
  getProductSkuSplitProperty,
  getProductModifiers,
  getSelectedAddonsList,
  getSelectedProductModifierOptions,
  getIsProductAddonModifierOptionInventoryPending,
} from '../../../store/selectors/product.selectors';
import {
  getQueryParams,
} from '../../../store/selectors/router.selectors';
import {
  fetchProductDetails,
  setAddOnModifiers,
  toggleModifierOption,
} from '../../../store/actions/product.actions';
import {
  generateBXProductData,
  getActiveOptionFromModifiers,
} from '../../global/ProductHelpers';

export class ProductModifiers extends Component {
  constructor(props) {
    super(props);

    this.renderModal = this.renderModal.bind(this);
    this.renderCheckbox = this.renderCheckbox.bind(this);
    this.renderPickListModifier = this.renderPickListModifier.bind(this);
    this.renderListModifier = this.renderListModifier.bind(this);
    this.renderAddToCartModifier = this.renderAddToCartModifier.bind(this);
    this.renderModifiers = this.renderModifiers.bind(this);
    this.renderModifierGroup = this.renderModifierGroup.bind(this);
    this.renderAddOnModifiers = this.renderAddOnModifiers.bind(this);
  }

  componentDidMount() {
    this.addBXWindowObject();
  }

  componentDidUpdate() {
    this.addBXWindowObject();
  }

  addBXWindowObject() {
    const {
      productDetails,
    } = this.props;
    window.bx = productDetails && generateBXProductData(productDetails.sku);
  }

  renderModal(modal) {
    const {
      fetchProductDetailsAction,
    } = this.props;

    return modal && (
      <DetailsModal
        teaserCopy={modal.teaserCopy}
        teaserIcon={modal.teaserIcon}
        salesTiers={modal.salesTiers}
        popUpCopy={modal.copy}
        fetchProductDetails={fetchProductDetailsAction}
        header={modal.header}
        footnote={modal.footnote}
        asset={modal.assets && modal.assets[0]}
        links={modal.links}
      />
    );
  }

  renderCheckbox(option, onChange) {
    return (
      <div
        className="pdp-options-checkbox-wrapper"
      >
        <div
          className={`pdp-options-checkbox ${option.className ? `checkbox-${option.className}` : ''} ${option.active ? 'active' : ''}`}
          onClick={onChange}
        >
          <input
            type="checkbox"
            name={option.value}
            aria-label={option.description}
            defaultChecked={option.active}
            className={'pdp-options-checkbox-input'}
          />
          <span className="pdp-options-checkbox-label">{option.description}</span>&nbsp;
          {option.priceAdjust && (
            <span className="pdp-options-checkbox-price">+ ${option.priceAdjust}</span>
          )}
        </div>
        {option.modals && this.renderModal(option.modals[0])}
      </div>
    );
  }

  renderPickListModifier(modifier, i, optionType = 'checkbox') {
    const { options = [], slug, title } = modifier;
    return (
      <div key={i} className={`pdp-options ${slug || ''}`}>
        <div className={`pdp-options-header ${slug || ''}`}>
          <div className="pdp-options-header-title">{title}</div>
        </div>
        <div key={i} className="pdp-options-wrapper addOns">
          {options.map((option, j) => (
            <div
              key={j}
              className={`pdp-options-${optionType} ${optionType}-${option.className} ${option.selected ? 'active' : ''}`}
            >
              {this.renderCheckbox(option, this.props.toggleModifierOptionAction.bind(this, { modifier, option }))}
            </div>
          ))}
        </div>
      </div>
    );
  }

  renderListModifier(modifier, i) {
    return (
      <ListModifier
        {...this.props}
        modifier={modifier}
        key={i}
      />
    );
  }

  renderAddToCartModifier(modifier, i, optionType = 'checkbox') {
    const {
      options = [],
      slug = '',
      title,
    } = modifier;
    const { relatedProducts = [] } = this.props.productDetails;
    return options.length > 0 && (
      <div key={i} className={`pdp-options ${slug}`}>
        <div className={`pdp-options-header ${slug}`}>{title}</div>
        <div key={i} className="pdp-options-wrapper addOns">
          {options
            .filter((option) => {
              const formattedValue = option.value.substring(0, option.value.lastIndexOf('_'));
              const isRelatedProduct = relatedProducts.some(({ sku }) => sku.includes(formattedValue || option.value));
              return (
                // ensure that the product (if it exists) is in the related SKUs
                isRelatedProduct || option.value === 'NONE'
              );
            })
            .map((option, j) => (
              <div
                key={j}
                className={`pdp-options-${optionType} ${optionType}-${option.className} ${option.selected ? 'active' : ''}`}
              >
                {this.renderCheckbox(option, this.props.toggleModifierOptionAction.bind(this, { modifier, option }))}
              </div>
            ))}
        </div>
      </div>
    );
  }

  renderAddOnModifiers(modifier, i) {
    const {
      options,
      requiredActiveModifierOptions,
      activeStateProp,
    } = modifier;
    const {
      addOnModifiers,
      selectedModifierOptions,
    } = this.props;
    const formattedStateProp = lowerFirst(activeStateProp);
    // If all the requiredActiveModifierOptions have been selected
    const shouldRenderAddOnModifier = requiredActiveModifierOptions?.every((requiredModifier) => (
      selectedModifierOptions.some((modifierOption) => (
        modifierOption.value === requiredModifier.value
      ))
    ));

    return shouldRenderAddOnModifier ? (
      <div key={i} className="pdp-options-wrapper addon-selector">
        {options.map((option) => {
          const {
            value,
            selected,
          } = option;
          const active = selected || addOnModifiers[formattedStateProp] === value || (!addOnModifiers[formattedStateProp] && value === this.props[formattedStateProp]);
          return (
            <div
              key={value}
              className={classNames('pdp-options-addon-selector', {
                active,
              })}
              onClick={this.props.toggleModifierOptionAction.bind(this, { modifier, option })}
            >
              <span className={`color-${value}`}/>
              <span>{option.description}</span>
            </div>
          );
        })}
      </div>
    ) : null;
  }

  renderModifiers(modifiers) {
    return modifiers.map((modifier, i) => {
      const modifierToRender = { ...modifier };
      let styleToRender = modifierToRender.modifierStyle || modifierToRender.type || modifierToRender.modifierOperation;
      // Render headboard add-ons as List
      // render headboard add-on colors as ColorPicker
      if ((styleToRender === 'AddToCart' || styleToRender === 'AttachAddonItem') && modifierToRender.slug === 'headboard-add-on') {
        styleToRender = 'List';
        // eslint-disable-next-line no-param-reassign
        modifierToRender.type = styleToRender;
      } else if ((styleToRender === 'AddToCartModifier' || styleToRender === 'UpdateAddonItemVariant') && modifierToRender.slug === 'headboard-color') {
        styleToRender = 'ColorPicker';
      }

      const modifierProps = {
        modifier,
        key: i,
        selectedModifierOptions: this.props.selectedModifierOptions,
        disabled: this.props.isProductDataPending || this.props.isProductAddonModifierOptionInventoryPending,
        fetchProductDetailsAction: this.props.fetchProductDetailsAction,
        toggleModifierOptionAction: this.props.toggleModifierOptionAction,
        withRedirect: this.props.withRedirect,
        productDetails: this.props.productDetails,
      };

      switch (styleToRender) {
        case 'Icons':
          return (
            <IconsModifier
              {...modifierProps}
            />
          );
        case 'Buttons':
          return (
            <ButtonsModifier
              {...modifierProps}
            />
          );
        case 'Tabs':
          return (
            <TabsModifier
              {...modifierProps}
            />
          );
        case 'RadioDials':
          return (
            <RadioDialsModifier
              {...modifierProps}
            />
          );
        case 'Checkbox':
          return (
            <CheckboxModifiers
              {...modifierProps}
            />
          );
        case 'Counter':
          return (
            <CounterModifier
              {...modifierProps}
            />
          );
        case 'List':
        case 'ColorPicker':
          return this.renderListModifier(modifierToRender, i);
        case 'PickList':
          return this.renderPickListModifier(modifierToRender, i);
        case 'AddToCart':
          return this.renderAddToCartModifier(modifierToRender, i);
        case 'AddToCartModifier':
          return this.renderAddOnModifiers(modifierToRender, i);
        default:
          return null;
      }
    });
  }

  renderModifierGroup([groupTitle, groupModifiers]) {
    if (groupModifiers.length > 1) {
      const {
        productDetails,
        selectedModifierOptions,
        ...otherProps
      } = this.props;

      const { activeModifier, activeOption } = getActiveOptionFromModifiers({
        modifiersList: groupModifiers,
        productDetails,
        selectedModifierOptions,
        otherProps,
      });

      const shouldShowModifierValue = activeModifier?.onSelectFunction === 'SetMaterialColor' && activeModifier.showModifierValue;

      return (
        <div
          className={`pdp-options-group ${groupTitle.toLowerCase()}`}
          aria-label={groupTitle}
          key={groupTitle}
        >
          <div className="pdp-options-group__header">
            <span className="pdp-options-group__header-title">{groupTitle}</span>
            {shouldShowModifierValue && (
              <span className="pdp-options-group__header-value">{activeOption?.description}</span>
            )}
          </div>
          {this.renderModifiers(groupModifiers)}
        </div>
      );
    }
    return this.renderModifiers(groupModifiers);
  }

  render() {
    const { productModifiers } = this.props;
    const groupedOptions = groupBy(productModifiers, 'title');
    return Object.entries(groupedOptions).map(this.renderModifierGroup);
  }
}

ProductModifiers.propTypes = {
  activeSeat: PropTypes.string,
  activeLegs: PropTypes.string,
  activeColor: PropTypes.string,
  activeLegStyle: PropTypes.string,
  activeCushionColor: PropTypes.string,
  activeMaterial: PropTypes.string,
  salePrice: PropTypes.string,
  productDetails: PropTypes.shape({
    sku: PropTypes.string,
  }).isRequired,
  selectedModifierOptions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
    }),
  ),
};

const mapStateToProps = (state) => ({
  productDetails: getProductDetails(state),
  productModifiers: getProductModifiers(state),
  activeFurnitureType: getProductSkuSplitProperty(state, 'furnitureType'),
  activeColor: getProductSkuSplitProperty(state, 'color'),
  activeArms: getProductSkuSplitProperty(state, 'arms'),
  activeSeat: getProductSkuSplitProperty(state, 'size'),
  activeLegs: getProductSkuSplitProperty(state, 'legs'),
  activeLegStyle: getProductSkuSplitProperty(state, 'legStyle'),
  activeCushionColor: getProductSkuSplitProperty(state, 'cushionColor'),
  activeMaterial: getProductSkuSplitProperty(state, 'material'),
  activeTableFinish: getActiveTableFinish(state),
  addOnModifiers: getAddOnModifiers(state),
  isProductDataPending: getIsProductDataPending(state),
  selectedAddons: getSelectedAddonsList(state),
  selectedModifierOptions: getSelectedProductModifierOptions(state),
  queryParams: getQueryParams(state),
  isProductAddonModifierOptionInventoryPending: getIsProductAddonModifierOptionInventoryPending(state),
});

const mapDispatchToProps = {
  fetchProductDetailsAction: fetchProductDetails,
  setAddOnModifiersAction: setAddOnModifiers,
  toggleModifierOptionAction: toggleModifierOption,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductModifiers);
